import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens, Button } from '@hotjar/hotsauce';

const bounceIn = keyframes`
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }

  75% {
    transform: translate3d(0, 10px, 0));
  }

  90% {
    transform: translate3d(0, -5px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;

export const WidgetWrapper = styled.div`
  font-family: ${tokens.FONT_FAMILY}, sans-serif, Arial;
  box-sizing: border-box;
  padding: 72px ${tokens.spacer.x3} ${tokens.spacer.x3};
  background-color: white;
  color: ${tokens.color.neutral_600};
  position: fixed;
  z-index: 1000;
  bottom: ${tokens.spacer.x8};
  right: ${tokens.spacer.x2};
  border-radius: 4px;
  overflow: hidden;
  width: 304px;
  min-height: 176px;
  max-height: 448px;
  animation: ${bounceIn} 1s ease 1;
  ${tokens.elevation(3)};
`;

export const WidgetTitleBar = styled.div`
  background-color: white;
  box-sizing: inherit;
  width: 100%;
  position: absolute;
  padding: ${tokens.spacer.x3} ${tokens.spacer.x3} ${tokens.spacer.x1};
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  ${tokens.text('caption')}
`;

export const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  position: relative;
  right: 0;
  align-self: flex-start;
  margin-left: auto;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  box-shadow: none;
  padding: 0;

  &:hover {
    background-color: transparent;
    box-shadow: none;
  }
`;

export const Title = styled.p`
  margin: 0 0 0 ${tokens.spacer.x2};
`;

export const WidgetContent = styled.div<{ hasCTA: boolean }>`
  min-height: 80px;
  max-height: 352px;
  overflow-y: scroll;
  margin-right: -${tokens.spacer.x3};
  padding-right: ${tokens.spacer.x3};
  background: ${tokens.color.white};
  color: ${tokens.color.neutral_700};

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: white;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${tokens.color.neutral_200};
    outline: 1px solid ${tokens.color.neutral_200};
  }

  h2,
  h3,
  h4 {
    margin: 0 0 ${tokens.spacer.x1};
    ${tokens.text('caption')}
    font-weight: bold;
  }

  p {
    margin: 0 0 ${tokens.spacer.x1};
    ${tokens.text('caption')}
  }

  p:last-of-type {
    padding-bottom: ${({ hasCTA }) => (hasCTA ? '60px' : '0')};
  }

  a {
    text-decoration: none;
    color: ${tokens.color.link};
  }

  img {
    margin: 0 0 ${tokens.spacer.x1};
    width: 100%;
    object-fit: contain;
  }
`;

export const WidgetCTASection = styled.div`
  position: absolute;
  z-index: 1000;
  bottom: 0;
  left: 0;
  width: calc(100% - 10px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
`;

export const CTAButton = styled(Button)`
  width: calc(100% + 12px);
  margin: ${tokens.spacer.x2} 15px ${tokens.spacer.x3} ${tokens.spacer.x3};
`;
